import { render, staticRenderFns } from "./box-bottom-menu.vue?vue&type=template&id=11efc474&"
import script from "./box-bottom-menu.vue?vue&type=script&lang=js&"
export * from "./box-bottom-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports